import BigNumber from 'bignumber.js';
import { curry } from 'ramda';

export const expandDecimals = curry((decimals: number | string, value: string) =>
  new BigNumber(value).shiftedBy(Number(decimals)).dp(0).toString(),
);
